<template>
  <transition name="fade">
  <div class="question quesiton-number box box-shadow">

    <div class="question--question" v-html="question"></div>

    <div class="answer form-group">
      <textarea 
        class="form-control" 
        v-bind:value="value"
        v-on:input="doUpdate" 
        placeholder="Write your answer"
      ></textarea>
    </div>

    <footer>Q ID: {{id}} : {{index}}</footer>

  </div>
  </transition>
</template>

<script>
import Question from '@/components/questions/Question'
export default {
  name: 'TextQuestion',
  extends: Question,
  methods: {
    doUpdate ($event) {
      this.$emit('input', $event.target.value)
    }
  }
}
</script>

<style scoped>

  textarea{
    width: 100%;
  }


  input {
    text-align: center;
  }
</style>
 


// WEBPACK FOOTER //
// src/components/questions/Text.vue